module.exports = __webpack_public_path__ + "static/media/dollar-orange.e8f0c42a.svg";